import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { EditPlannerElementSetRoute } from "./routes";
export default store => ({
  path: ":plannerElementSetId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "data-sets" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [EditPlannerElementSetRoute(store)],
});
